import {
	ADD_CLIENT_TO_GROUP,
	ADD_CLIENT_TO_GROUP_ERROR,
	ADD_CLIENT_TO_GROUP_SUCCESS,
	CLEAR_PROFILE,
	CREATE_CALENDAR,
	CREATE_CALENDAR_ERROR,
	CREATE_CALENDAR_SUCCESS,
	FETCH_CALENDAR_EVENTS,
	FETCH_CALENDAR_EVENTS_ERROR,
	FETCH_CALENDAR_EVENTS_SUCCESS,
	FETCH_GROUPS,
	FETCH_GROUPS_ERROR,
	FETCH_GROUPS_SUCCESS,
	FETCH_OQ_CHART,
	FETCH_OQ_CHART_ERROR,
	FETCH_OQ_CHART_SUCCESS,
	FETCH_PATIENT_DOCS,
	FETCH_PATIENT_DOCS_ERROR,
	FETCH_PATIENT_DOCS_SUCCESS,
	FETCH_PATIENT_GROUPS,
	FETCH_PATIENT_GROUPS_ERROR,
	FETCH_PATIENT_GROUPS_SUCCESS,
	FETCH_PATIENT_PROFILE,
	FETCH_PATIENT_PROFILE_ERROR,
	FETCH_PATIENT_PROFILE_SUCCESS,
	UPDATE_ENROLLMENT,
	UPDATE_ENROLLMENT_ERROR,
	UPDATE_ENROLLMENT_SUCCESS,
	UPDATE_PATIENT_INFO,
	UPDATE_PATIENT_INFO_ERROR,
	UPDATE_PATIENT_INFO_SUCCESS,
	UPDATE_USER_CALENDAR_INFO,
} from './constants';

import { fromJS } from 'immutable';

export const initialState = fromJS({
	userInfo: {},
	isUpdating: false,
	loadingInfo: true,
	userError: false,
	groups: [],
	allGroups: [],
	loadingGroups: false,
	calendarEvents: [],
	loadingCalendar: false,
	isCreatingCalendar: false,
	updateSuccess: false,
	updateError: false,
	error: '',
	docs: [],
	requests: [],
	isAdding: false,
	addingError: '',
		oqChartUrl: null,
		subscoreChartUrl: null,
		oqChartStatus: 'idle', // 'idle' | 'loading' | 'succeeded' | 'failed'
	});
	
	function patientProfileReducer(state = initialState, action) {
		switch (action.type) {
			case FETCH_PATIENT_PROFILE:
				return state.merge({
					userError: false,
					loadingInfo: true,
				});
			case FETCH_PATIENT_PROFILE_ERROR:
				return state.merge({
					userError: true,
					loadingInfo: fromJS(false),
				});
			case FETCH_PATIENT_PROFILE_SUCCESS:
				return state.merge({
					userError: false,
					userInfo: fromJS(action.payload),
					loadingInfo: fromJS(false),
				});
	
			case FETCH_CALENDAR_EVENTS:
				return state.set('loadingCalendar', true);
			case FETCH_CALENDAR_EVENTS_ERROR:
				return state.merge({
					error: fromJS(action.error),
					loadingCalendar: fromJS(false),
				});
			case FETCH_CALENDAR_EVENTS_SUCCESS:
				return state.merge({
					calendarEvents: fromJS(action.events),
					loadingCalendar: fromJS(false),
				});
	
			case CREATE_CALENDAR:
				return state.set('isCreatingCalendar', true);
			case CREATE_CALENDAR_SUCCESS:
			case CREATE_CALENDAR_ERROR:
				return state.set('isCreatingCalendar', false);
	
			case FETCH_GROUPS:
				return state.merge({
					isFetchingGroups: true,
					allGroups: [],
					fetchingGroupsError: '',
				});
			case FETCH_GROUPS_SUCCESS:
				return state.merge({
					isFetchingGroups: false,
					allGroups: action.data,
					fetchingGroupsError: '',
				});
			case FETCH_GROUPS_ERROR:
				return state.merge({
					isFetchingGroups: false,
					allGroups: [],
					fetchingGroupsError: action.error,
				});
	
			case ADD_CLIENT_TO_GROUP:
				return state.merge({
					isAdding: true,
					addingError: '',
				});
			case ADD_CLIENT_TO_GROUP_SUCCESS:
				return state.merge({
					isAdding: false,
					addingError: '',
				});
			case ADD_CLIENT_TO_GROUP_ERROR:
				return state.merge({
					isAdding: false,
					addingError: action.error,
				});
	
			case UPDATE_PATIENT_INFO:
				return state.merge({
					updateError: false,
					updateSuccess: false,
					isUpdating: true,
					loadingInfo: true,
				});
			case UPDATE_PATIENT_INFO_ERROR:
				return state.merge({
					updateError: true,
					isUpdating: false,
					loadingInfo: false,
				});
			case UPDATE_PATIENT_INFO_SUCCESS:
				return state.merge({
					updateSuccess: true,
					isUpdating: false,
					loadingInfo: false,
				});
	
			case FETCH_PATIENT_GROUPS:
				return state.set('loadingGroups', true);
			case FETCH_PATIENT_GROUPS_ERROR:
				return state.merge({
					error: fromJS(action.error),
					loadingGroups: fromJS(false),
				});
			case FETCH_PATIENT_GROUPS_SUCCESS:
				return state.merge({
					groups: fromJS(action.payload),
					loadingGroups: false,
				});
	
			case UPDATE_ENROLLMENT:
				return state.merge({
					updateError: false,
					updateSuccess: false,
				});
			case UPDATE_ENROLLMENT_ERROR:
				return state.merge({
					updateError: true,
					updateSuccess: false,
				});
			// The saga refetches the patient's groups, so there is nothing to patch here:
			// a save can create and delete instances, not just move dates.
			case UPDATE_ENROLLMENT_SUCCESS:
				return state.merge({
					updateError: false,
					updateSuccess: true,
				});
	
			case FETCH_PATIENT_DOCS:
				return state.set('loadingDocs', true);
			case FETCH_PATIENT_DOCS_ERROR:
				return state.merge({
					error: fromJS(action.error),
					loadingDocs: fromJS(false),
				});
			case FETCH_PATIENT_DOCS_SUCCESS:
				return state.merge({
					docs: fromJS(action.userDocs),
					requests: fromJS(action.requests),
					loadingDocs: fromJS(false),
				});
	
			case FETCH_OQ_CHART:
				return state.set('oqChartStatus', 'loading');
			case FETCH_OQ_CHART_SUCCESS:
				return state.merge({
					oqChartStatus: 'succeeded',
					oqChartUrl: action.payload.chartUrl,
					subscoreChartUrl: action.payload.subscoreChartUrl,
				});
			case FETCH_OQ_CHART_ERROR:
				return state.set('oqChartStatus', 'failed');
	
			case UPDATE_USER_CALENDAR_INFO:
				return state.mergeIn(['userInfo'], {
					googleCalendarId: action.payload.id,
					googleCalendarHtmlLink: action.payload.htmlLink,
				});
	
			case CLEAR_PROFILE:
				return state.merge({
					userInfo: {},
					docs: [],
					calendarEvents: [],
					groups: [],
					oqChartUrl: null,
					subscoreChartUrl: null,
					oqChartStatus: 'idle',
				});
			default:
				return state;
		}
	}
	
	export default patientProfileReducer;

